module.exports = __webpack_public_path__ + "img/thumb-preview-stop.svg";